import type { CogentLive } from "../chat/chat-view";
import s from "../cogent.module.css";

/** The native controller owns delivery, observation deadlines, and error recovery. */
export function WidgetLiveStatus({
  live,
}: {
  readonly live: CogentLive | null;
}) {
  return live?.recovery ? (
    <output
      className={s.soft}
      data-testid="cogent-recovery"
      role={live.recovery.attention ? "alert" : undefined}
    >
      {live.recovery.title}
      {live.recovery.detail ? `: ${live.recovery.detail}` : ""}
    </output>
  ) : null;
}
